var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.667 11.75a.75.75 0 0 1 0 1.5H2.334a.75.75 0 0 1 0-1.5zM14.334 8.75a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5zM11.667 5.75a.75.75 0 0 1 0 1.5H2.334a.75.75 0 0 1 0-1.5zM14.334 2.75a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1 0-1.5z"
  })));
};
export default Svg16;